import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Checkbox } from '../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { Icon } from '../../../../../CommonComponents/OPL/Icon/Icon';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { TruncatedText } from '../../../../../CommonComponents/OPL/Text/TruncatedText';
import { ColumnWidths } from '../../../../DocumentVault.meta';
import { EntityIcon } from '../../../EntityIcon/EntityIcon';
import { useOrganizeItemsContext } from '../../context/useOrganizeItemsContext';
import { Tooltip } from '../../../../../CommonComponents/OPL/Tooltip/Tooltip';

export const SelectItems = () => {
  const {
    sourceEntities: { items },
    sourcePath,
    setSourcePath,
    onClose,
    onNext,
  } = useOrganizeItemsContext();

  return (
    <>
      <ModalBody>
        <Text fontWeight={600}>Select which items you want to move:</Text>

        <Box
          display="flex"
          flexDirection="column"
          css={({ theme }) => ({ gap: theme.space[8] })}
          mt="16"
        >
          {items.map((entity, index) => {
            return (
              <React.Fragment key={index}>
                <Box flex={ColumnWidths.Name} display="flex" alignItems="center">
                  <Checkbox
                    key={index}
                    disabled={entity.isReadOnly}
                    checked={sourcePath.includes(entity.path)}
                    onChange={() => {
                      if (sourcePath.includes(entity.path)) {
                        setSourcePath([...sourcePath.filter(item => item !== entity.path)]);
                      } else {
                        setSourcePath([...sourcePath, entity.path]);
                      }
                    }}
                    mb="4"
                  >
                    <Box display="flex" alignItems="center">
                      <EntityIcon entity={entity} fontSize="h5" mr="4" />

                      <TruncatedText fontWeight={500}>{entity.name}</TruncatedText>
                    </Box>
                  </Checkbox>

                  {entity.isReadOnly && (
                    <Tooltip content="Folder is read-only" placement="top">
                      <Icon className="far fa-info-circle" color="neutral.500" ml="4" />
                    </Tooltip>
                  )}
                </Box>
              </React.Fragment>
            );
          })}
        </Box>
      </ModalBody>

      <ModalFooter>
        <Button
          variant="subtleInactive"
          mr="8"
          onClick={() => {
            onClose();
          }}
        >
          Close
        </Button>

        <Button
          disabled={sourcePath.length === 0}
          onClick={() => {
            onNext();
          }}
        >
          Move {sourcePath.length} item{sourcePath.length === 1 ? '' : 's'}
        </Button>
      </ModalFooter>
    </>
  );
};
